<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" class="page"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" class="page"></router-view>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "App",
  created() {
    const { token, refreshToken } = this.$route.query;
    if (token) {
      localStorage.setItem("token", token);
      if (this.$route.name) {
        const { query } = this.$route;
        const newQuery = {};
        for (var key in query) {
          if (key != "token" && key != "refreshToken") {
            newQuery[key] = query[key];
          }
        }
        this.$router.push({
          name: this.$route.name,
          query: newQuery
        });
      }
    }
    if (refreshToken) {
      localStorage.setItem("refreshToken", refreshToken);
    }
    try {
      if (this.getHospitalInfo) {
        this.getHospitalInfo();
      }
    } catch (e) {}
  },
  updated() {},
  methods: {
    ...mapActions("home", ["getHospitalInfo"])
  }
};
</script>

<style>
@media screen and (max-width: 415px) and (min-width: 401px) {
  html,
  body,
  #app {
    font-size: 16pt;
  }
}

@media screen and (max-width: 400px) and (min-width: 375px) {
  html,
  body,
  #app {
    font-size: 14pt;
  }
}

@media screen and (max-width: 374px) and (min-width: 350px) {
  html,
  body,
  #app {
    font-size: 14pt;
  }
}

@media screen and (max-width: 349px) and (min-width: 320px) {
  html,
  body,
  #app {
    font-size: 12pt;
  }
}

#app {
  height: 100%;
  overflow: hidden;
  color: #2c3e50;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body {
  -webkit-text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  margin: 0;
  padding: 0;
  border: 0;
}
body,
html {
  height: 100%;
  overflow: hidden;
}
.container {
  height: 100%;
  overflow: scroll;
}
.page {
  height: 100%;
  overflow: scroll;
}
</style>
